import { IntegrationServiceId } from '../../../../../common/integrations'
import { ClickNavigationSection } from '../../../../../components/NavigationWithSideBar/ClickNavigation'

import { CRMIntegrationTaskSettings } from '../CRMIntegrationTaskSettings'
import { RedtailCalendarSyncSettings } from './RedtailCalendarSyncSettings'
import { RedtailContactSyncSettings } from './RedtailContactSyncSettings'

export const RedtailSpecificSettings = (): ClickNavigationSection[] => {
  return [
    { id: 'contactSync', label: 'Contact Sync', content: () => <RedtailContactSyncSettings /> },
    { id: 'calendarSync', label: 'Calendar Sync', content: () => <RedtailCalendarSyncSettings /> },
    { id: 'task', label: 'Task', content: () => <CRMIntegrationTaskSettings serviceId={IntegrationServiceId.REDTAIL} /> },
  ]
}
